/**
 * 模拟考试卡片
 */
export default {
  difficulty: '난이도',
  mockDuration: '모의고사 기간',
  intro: '간단한 소개',
}
